<template>
  <v-dialog v-model="isUploading" max-width="400px" :persistent="true">
    <v-card class="pa-1">
      <v-card-title class="pt-3 pl-3 pb-0">
        <span class="body-2">{{ progressMessage }}</span>
      </v-card-title>
      <v-card-title class="pa-3">
        <progress
          class="progress-bar"
          max="100"
          
          :value.prop="uploadPercentage"
        ></progress>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import AppUpload from '@/plugins/upload.js'

export default {
  name: 'AppError',
  data() {
    return {
      formData: null,
      url: null,
      fileCount: 0,

      isUploading: false,
      uploadPercentage: 0,
      progressMessage: null,
      progressExpression: 'UploadingXFiles',
      onComplete: {}
    }
  },
  methods: {
    execute (params) {
      const self = this
      if (self.isNullOrUndefined(params.formData)) return
      if (self.isNullOrUndefined(params.url)) return
      if (!self.isNullOrUndefined(params.onComplete)) self.onComplete = params.onComplete
      if (!self.isNullOrUndefined(params.languageId)) self.languageId = params.languageId
      if (!self.isNullOrUndefined(params.progressExpression)) self.progressExpression = params.progressExpression

      self.isUploading = true
      self.progressMessage = self.getExpression('Alert', self.progressExpression).replace('{0}', params.fileCount)

      axios.post(params.url, params.formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            self.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            )
            if (self.uploadPercentage >= 100) {
              setTimeout(function() {
                self.progressMessage = self.getExpression('Alert', 'Finalizing')
              }, 500)
            }
          }
        })
        .then((response) => {
          self.uploadPercentage = 0
          const data = response.data
          self.complete(data)
        })
        .catch(() => {
          // console.error('Upload failed: ' + e.response)
        })
    },
    complete (data) {
      if (typeof this.onComplete === 'function') {
        this.isUploading = false
        this.onComplete(data)
      }
    }
  },
  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    AppUpload.EventBus.$on('execute', (params) => {
      this.execute(params)
    })
  }
}
</script>

<style scoped>
progress::-moz-progress-bar { background: #2ba832; }
progress::-webkit-progress-value { background: #2ba832; }
progress { color: #2ba832; }

.progress-bar {
  width: 100%;
  border: 0;
  height: 18px;
  border-radius: 9px;
}
</style>
